import { useMemo } from "react"

import eq from "lodash-es/eq"
import { useOrientation as useReactOrientation } from "react-use"
import { type OrientationState as ReactOrientationState } from "react-use/lib/useOrientation"

type TOrientation = { isPortrait: boolean; isLandscape: boolean }

function useOrientation(): TOrientation {
    const orientation: ReactOrientationState = useReactOrientation()

    return useMemo(
        (): TOrientation => ({
            isPortrait: eq(orientation.type, "portrait-primary"),
            isLandscape: eq(orientation.type, "landscape-primary")
        }),
        [orientation.type]
    )
}

export { useOrientation }
export type { TOrientation }
